module.exports = __webpack_public_path__ + "img/device_am_28.5d36d13b.png";